<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-06-23 17:44:37
 * @LastEditors: yd
 * @LastEditTime: 2020-12-09 17:05:16
-->
<template>
  <v-card>
    <!--白名单 -->
    <!-- <v-autocomplete v-model="states"
                    :items="list"
                    item-text="client_whitelist_email"
                    item-value="uuid"
                    chips
                    small-chips
                    :label="$t('label_Email_whitelist_Settings')+'*'"
                    multiple></v-autocomplete> -->
    <v-card-text>
      <v-combobox
        v-model="states"
        :label="$t('label_Email_whitelist_Settings')"
        multiple
        @keydown="keydown"
        :items="list"
        :placeholder="readonly ? ' ' : $t('label_Email_whitelist_Settings')"
        :validate-on-blur="true"
        item-text="whitelist_domain"
        item-value="uuid"
        :append-icon="readonly ? '' : 'arrow_drop_down'"
        chips
        @update:search-input="verifyemail"
        @input="emailverify"
        :error-messages="isemail"
        :readonly="readonly"
      ></v-combobox>
    </v-card-text>
    <slot name="submitBtn"> </slot>
  </v-card>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
    },
    list: {
      type: Array,
      default: () => {
        return []
      },
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      states: [], //默认显示
      disabled: false,
      select: [], //添加的数组
      datastorage: this.list, //保存已有数据
      isemail: '', //错误消息文本
    }
  },
  watch: {
    list: {
      handler(val) {
        this.states = val
      },
      deep: true,
    },
  },
  computed: {},
  mounted() {
    if (this.$store.state.detailuuid) {
      this.states = this.list
    } else {
    }
  },
  methods: {
    keydown(v) {
      if (v.keyCode == 13) {
        const isErr = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]|[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(
          v.target.value
        )
        if (isErr) {
          this.states.push(v.target.value)
        }
      }
    },
    verifyemail(v) {
      if (v != null && v != '') {
        const isErr = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]|[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(
          v
        )
        if (isErr) {
          this.isemail = ''
        } else {
          this.isemail = this.$t('verify_The_mailbox_format_is_wrong')
        }
      } else {
        this.isemail = ''
      }
    },
    emailverify(v) {
      if (this.isemail != '') {
        this.states.pop()
      }
    },
  },
}
</script>
